<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>
        <BreadcrumbItem>媒体发布</BreadcrumbItem>
        <BreadcrumbItem> 在线讲堂</BreadcrumbItem>
      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">

      <Col span='4'>
      <Input v-model="searchParam.title" placeholder="视频名称" />
      </Col>

      <Col span='1'>
      <Button type="info" @click='searchData'>查询</Button>
      </Col>
      <ul class='conheadRight'>
        <i-button type="error" @click='sModal(-1)'>发布视频</i-button>
      </ul>
    </Row>
    <Row id='pdData'>
      <div v-for='(item, index) in pdData' class='itempd' :class='[index == curIndex ? "active" : ""]'
        @click='tabPD(index, item)'>{{ item.name }}</div>
    </Row>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :emitrow='emitrow' :randomrow='randomrow' :searchParam='searchParam'
        :issearch='issearch' @smodal='sModal'></tablePage>
    </section>

    <Modal v-model="edit" title='视频片段发布/修改' width='700'>
      <div class='newPDvideo'>
        <i-button type="error" @click='sModal2(-1)'>发布视频片段</i-button>
      </div>


      <tablePage border :queryData="querypdData" :issearch='ispdsearch' @smodal='sModal2'></tablePage>
    </Modal>
    <bemodal :reloadtmp='reloadTmep' :formdata='formData' @reloadModalData='reloadTable'></bemodal>
    <bemodal :reloadtmp='reloadpdTmep' :formdata='formpdData' @reloadModalData='reloadpdTable'></bemodal>
  </section>
</template>

<script>
import getDates from '../utils/index'
import tablePage from './tablePage'
import bemodal from './formItemNoSch'
export default {
  name: 'noticelist',
  components: {
    tablePage,
    bemodal,
  },
  data () {
    return {
      edit: false,
      ispdsearch: -1,
      pdData: [],
      smodal: false,
      reloadpdTmep: -1,
      reloadTmep: -1,
      initformData: [],
      curSonItem: {},
      initformpdData: [],
      formpdData: [
        ['video/getId', 'video/save', 'video/delete'],
        [{
          type: 'input',
          title: '标题',
          name: 'title',
          model: '',
        },
        {
          type: 'uploadimg',
          title: '背景图',
          name: 'pic',
          pictype: {
            type: 'videobg'
          },
          model: '',
        },
        {
          type: 'video',
          title: '视频',
          name: 'url',
          pictype: {
            type: 'video'
          },
          model: ''
        },
        {
          type: 'hidden',
          children: [{
            name: 'guid',
            model: ''
          }, {
            name: 'remark',
            model: ''
          }, {
            name: 'pid',
            model: ''
          }]
        }
        ]
      ],
      formData: [
        ['video/getId', 'video/save', 'video/delete'],
        [{
          type: 'input',
          title: '标题',
          name: 'title',
          model: '',
        },
        {
          type: 'input',
          title: '适用于',
          name: 'title2',
          model: '',
          block: true,
        },
        {
          type: 'input',
          title: '知识点',
          name: 'pic2',
          model: '',
          block: true,
        },
        {
          type: 'input',
          title: '课程描述',
          name: 'url2',
          model: '',
        },
        {
          type: 'switch',
          title: '是否原创',
          name: 'isoriginal',
          model: false,
          block: true,
        },
        {
          type: 'selectVideo',
          title: '所属类别',
          name: 'itemid',
          model: '',
          chilrend: [],
          block: true,
        },
        {
          type: 'uploadimg',
          title: '背景图',
          name: 'pic',
          pictype: {
            type: 'videobg',
            size: '686*386'
          },
          model: '',

        },


        // {
        // 	type: 'input',
        // 	title: '超链接',
        // 	name: 'url',
        // 	model: ''
        // },
        // {type:'checkbox',title:'显示方式',children:[{name:'unshared',title:'独占方式显示（遮挡所有画面）',model:true}]},
        {
          type: 'video',
          title: '视频',
          name: 'url',
          pictype: {
            type: 'video'
          },
          model: ''
        },
        {
          type: 'hidden',
          children: [{
            name: 'guid',
            model: ''
          }, {
            name: 'remark',
            model: ''
          }]
        }
        ]
      ],
      querypdData: ['',
        [{
          title: '标题',
          key: 'title',
        },

        {
          title: '添加人',
          key: 'addusername',
          width: 200,
          align: 'center',
        },
        {
          title: '操作',
          slot: 'action',
          width: 100,
          align: 'center'
        }

        ]
      ],
      queryData: ['',
        [{
          title: '标题',
          key: 'title',
        },

        {
          title: '添加人',
          key: 'addusername',
          width: 200,
          align: 'center',
        },
        {
          title: '添加时间',
          key: 'addtime',
          width: 200,
          align: 'center',
        },
        {
          title: '',
          key: 'addusername',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  textDecoration: 'underline',
                  color: '#2d8cf0',
                  cursor: 'pointer'
                },
                on: {
                  click: () => {

                    this.curSonItem = params.row
                    this.querypdData[0] = 'video/getQueryList?pid=' +
                      params.row.guid


                    this.ispdsearch = Math.random()
                    this.edit = true

                  }
                }
              }, '片段管理')
            ]);


          }
        },
        {
          title: '状态',
          key: 'state',
          width: 80,
          align: 'center',
          render: (h, params) => {

            var _state = params.row.state
            if (_state == 1) {
              return h('span', {
                style: {
                  color: " #00d186",
                },
              }, '已发布')
            } else {
              return h('span', {
                style: {
                  color: " #ed4c78",
                },
              }, '未发布')
            }

          }
        },
        {
          title: '操作',
          width: 90,
          align: 'center',
          render: (h, params) => {
            var _state = params.row.state == 0 ? '发布' : '取消发布'
            var that = this
            return h('div', [
              h('Dropdown', {
                props: {
                  trigger: "click"
                },
                on: {
                  'on-click': (value) => {
                    ////console.log(value) //此处的value和下面DropdownMenu选项的name对应
                    if (value == 'submit') {
                      that.emitrow = params.row
                      that.randomrow = Math.random()

                    } else if (value == 'delete') {
                      if (params.row.state == 0) {
                        that.axios.post('video/updateVideoState', {
                          id: params.row.guid,
                          state: 1
                        }).then(res => {
                          ////console.log(res)
                          that.$Message.success(res.msg)

                          that.reloadTable()


                        })

                      } else {
                        this.$Modal.confirm({
                          title: '提示',
                          content: '<p>是否下架此视频？</p>',
                          onOk: () => {
                            that.axios.post(
                              'video/updateVideoState', {
                              id: params
                                .row
                                .guid,
                              state: 0
                            }).then(
                              res => {

                                that.$Message
                                  .success(
                                    res
                                      .msg
                                  )
                                that.reloadTable()
                              }).catch(function (
                                res) {
                                that.$Message
                                  .error(
                                    '系统异常'
                                  )
                              })
                          },
                          onCancel: () => {

                          }
                        });
                      }


                    }
                  }
                }
              }, [
                h('span', {
                  style: {
                    display: 'inline-block',
                    width: '60px',
                    height: '25px',
                    background: '#2db7f5',
                    borderRadius: '6px',
                    textAlign: 'center',
                    lineHeight: '25px',
                    color: '#fff',
                    fontSize: '12px',
                    cursor: 'pointer',
                    userSelect: 'none'
                  }
                }, [
                  h('span', '操作'),
                  h('Icon', {
                    props: {
                      type: 'md-arrow-dropdown'
                    }
                  })
                ]),
                h('DropdownMenu', {
                  slot: 'list'
                }, [
                  h('DropdownItem', {
                    props: {
                      name: 'submit',
                      slot: 'action',
                    }
                  }, '编辑'),
                  h('DropdownItem', {
                    props: {
                      name: 'delete'
                    }
                  }, _state),
                ])
              ])
            ])



          }
        }

        ]
      ],
      searchParam: {
        title: '',
      },
      issearch: -1,
      curIndex: 0,
      emitrow: {},
      randomrow: -1,
    }
  },
  mounted () {
    this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
    this.initformpdData = JSON.parse(JSON.stringify(this.formpdData[1]))
    this.getpdData()
  },
  methods: {
    downexe () {
      console.log(1)
      window.location.href = 'https://wjdayly.obs.cn-jssz1.ctyun.cn:443/apk/Video.exe'
    },
    tabPD (index, item) {
      this.queryData[0] = 'video/getQueryList'
      this.curIndex = index
      this.searchParam.itemid = item.guid
      this.searchData()
    },
    getpdData () {
      var that = this
      this.axios.get('dic/getQueryList', {
        params: {
          rootid: 'video'
        }
      }).then(res => {

        // var allData = {
        // 	name: '全部',
        // 	guid: '',
        // }
        // res.data.unshift(allData)
        that.pdData = res.data
        that.searchParam.itemid = res.data[0]['guid']
        that.queryData[0] = 'video/getQueryList'

        that.searchData()
      })
    },
    searchData () {
      this.issearch = Math.random()
    },
    sModal (guid) {


      if (this.formData[0][0].indexOf('?') > -1) {
        this.formData[0][0] = this.formData[0][0].split('?')[0]
      }
      this.formData[0][0] = this.formData[0][0] + '?id=' + guid
      if (guid == -1) {
        this.formData[1] = JSON.parse(JSON.stringify(this.initformData))
      }
      this.reloadTmep = Math.random()
    },
    sModal2 (guid) {

      var that = this
      if (this.formpdData[0][0].indexOf('?') > -1) {
        this.formpdData[0][0] = this.formpdData[0][0].split('?')[0]
      }
      this.formpdData[0][0] = this.formpdData[0][0] + '?id=' + guid
      if (guid == -1) {
        this.formpdData[1] = JSON.parse(JSON.stringify(this.initformpdData))
      }
      var qdata = this.formpdData[1]
      qdata.map(function (val, index) {
        if (val['type'] == 'hidden') {
          var child = val['children']
          child.map(function (c, i) {
            if (c['name'] == 'pid') {
              c['model'] = that.curSonItem.guid
            }
          })
        }
      })
      this.formpdData[1] = qdata
      this.reloadpdTmep = Math.random()

    },
    reloadpdTable () {
      this.ispdsearch = Math.random()
    },
    reloadTable () {
      this.issearch = Math.random()
    }
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
}

.demo-upload-list {
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  float: right;
  margin-right: 0px;
}

#pdData {
  display: flex;
  justify-content: flex-start;
}

.itempd {

  height: 32px;
  line-height: 32px;
  border-radius: 20px;
  padding: 0 15px;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer
}

.itempd.active {
  background-color: #00d186;
  border-color: #00d186;
  color: #fff;
}

.newPDvideo {
  text-align: right;
  margin: 0px 0px 20px;
}
</style>
